<template>
  <MDBCard class="with-category border-0">
    <router-link :to="!empty ? {
      name: 'productDetails', params: {
        id: props.product && props.product.id ? props.product.id : 0
      }
    } : { name: 'shop' }
      ">
      <MDBCardBody>
        <div v-if="props.product && props.product.category" class="category">
          {{ props.product.category }}
        </div>
        <div v-if="isVariant" class="variant-info text-center">{{ $t('dashboard.shop.variant') }} </div>

        <MDBCardText>
          <template v-if="empty">
            {{ $t("dashboard.shop.noProducts") }}
          </template>
          <template v-else>
            <div class="product-image d-flex align-items-center justify-content-center">
              <img :src="productImgSrc" class="" alt="product image" draggable="false" />
            </div>

            <p class="font-16 index-order-top product-list-points"
              :class="affordable ? 'text-orange' : 'success-green'">
              {{ $t("dashboard.shop.forPoints", { points: productPoints }) }}
            </p>

            <h6 class="fw-medium text-dark index-order-top product-list-title"
              v-html="props.product?.name?.[currentLocale] || ''"></h6>

            <p class="font-12 availability" :class="affordable ? 'text-orange' : 'success-green'">
              <template v-if="affordable">
                {{ $t("dashboard.shop.remainingPoints", { points: remainingPoints }) }}
              </template>
              <template v-else>
                {{ $t("dashboard.shop.reachedPoints") }}
              </template>
            </p>
          </template>
        </MDBCardText>
      </MDBCardBody>
    </router-link>
  </MDBCard>
</template>

<script setup>
import { MDBCard, MDBCardBody, MDBCardText } from "mdb-vue-ui-kit";
import { useStore } from "vuex";
import { defineProps, computed } from "vue";

const props = defineProps({
  product: Object,
  empty: {
    type: Boolean,
    default: false,
  },
});

const store = useStore();
const currentLocale = computed(() => store.getters.getCurrentLocale);
const product = computed(() => {
  if (!props.product) {
    return null;
  }
  if (
    props.product.has_variants &&
    Array.isArray(props.product.variants)
  ) {
    let defaultVariant = props.product.variants.find(
      (item) => item.is_default == true
    );
    return defaultVariant;
  } else {
    return props.product;
  }
});

const isVariant = computed(() => {
  if (!props.product || !props.product.has_variants) {
    return false;
  }
  return Array.isArray(props.product.variants) && props.product.variants.length > 1;
});

const productImgSrc = computed(() => {
  if (!props.product) {
    return "";
  }
  return props.product.has_variants
    ? product.value?.imageUrl
    : props.product.imageUrl;
});

const productPoints = computed(() => {
  if (!props.product) {
    return 0;
  }
  return props.product.has_variants
    ? product.value?.points ?? 0
    : props.product.points ?? 0;
});

const user = computed(() => store.getters.getMe);

const affordable = computed(() => {
  return remainingPoints.value > 0;
});

const remainingPoints = computed(() => {
  const availablePoints = user.value?.points?.avail_points ?? 0;
  return productPoints.value - availablePoints;
});
</script>

<style scoped lang="scss">
@import "../../styles/variables";
@import "../../styles/product_list_item";
</style>
